var render = function (_h,_vm) {var _c=_vm._c;return _c('SocialImage',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass],attrs:{"title":"LinkedIn","channel":"linkedin"}},'SocialImage',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }